module.exports = __webpack_public_path__ + "static/media/Fraz_Liaqat_Resume.0873e687.pdf";